<harp-table
  [columns]="columns"
  [formName]="formName"
  [data]="devices"
  [totalEntries]="devices.length"
  [injector]="injector"
></harp-table>
